<template>
  <button v-on.native="$listeners"
          v-bind="$attrs"
          :disabled="disabled"
          :class="{ 'base-button__disabled': this.disabled }"
          class="base-button"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  border: 1px solid;
  border-radius: 8px;
  font-size: 18px ;
  font-weight: 600 ;
  text-align: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #F4F7F8;
  cursor: pointer;
  background: blueviolet;

  &__disabled {
    background: #b9b9bc;
    color: black;
    border-color: black;
  }
}
</style>